import { Typography } from "@material-ui/core";
import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import withWidth, { isWidthUp } from "@material-ui/core/withWidth";
import {  getSystemLabel } from "src/constant/Messages";

const useStyles = makeStyles((theme) => ({
  hitypography : {
    color: theme.palette.common.white,
      fontSize: theme.typography.logo.fontSize,
      fontWeight: "bold",
  },
  hitypographyxs : {
    color: theme.palette.common.white,
      fontSize: theme.typography.logoxs.fontSize,
      fontWeight: "bold",
  }
}));

const Logo = (props) => {
  const classes = useStyles();

  return isWidthUp("sm", props.width) ? (
      <Typography component="h1" className={classes.hitypography}>
        Portal KM {getSystemLabel('programShortcut', props.systemInfo)}
        {props.systemInfo ? (
          <Typography variant="body2" component="span">
            {" "}
            {props.systemInfo.systemVersion}
          </Typography>
        ) : (
          <></>
        )}
      </Typography>
  ) : (
      <Typography component="h1" className={classes.hitypographyxs}>
        Portal KM <br></br> {getSystemLabel('programShortcut', props.systemInfo)}
        {props.systemInfo ? (
          <Typography variant="body2" component="span">
            {" "}
            {props.systemInfo.systemVersion}
          </Typography>
        ) : (
          <></>
        )}
      </Typography>
  );
};

export default withWidth()(Logo);
